module.exports = __webpack_public_path__ + "aave_icon.svg?3f624769537ffdeaff8f53c7fbba1a37";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/aave_icon.svg
// module id = 1147
// module chunks = 2